import { IState } from '../../store';

export function mortgageSelector(state: IState) {
  return state.mortgage;
}
